// Two things live here:
//   1. Buy now: add the product to the cart, then go straight to checkout.
//   2. Quantity tiers: selecting a tier sets the hidden quantity field.
// Both use delegated listeners, so they survive any re-render of the form.
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHECKOUT_URL = ROOT + 'checkout';
  var CART_ADD_URL = ROOT + 'cart/add.js';

  function buyNow(btn) {
    var form = btn.closest('form');
    if (!form) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        window.location.href = CHECKOUT_URL;
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
  }

  function syncTier(radio) {
    var form = radio.closest('form');
    if (!form) return;
    var qty = form.querySelector('[data-qty]');
    if (qty) qty.value = radio.value;
    form.querySelectorAll('.tier').forEach(function (row) {
      var input = row.querySelector('[data-tier]');
      row.classList.toggle('is-selected', !!input && input.checked);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-buy-now]');
    if (btn) buyNow(btn);
  });

  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-tier]');
    if (radio) syncTier(radio);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var checked = document.querySelector('[data-tier]:checked');
    if (checked) syncTier(checked);
  });
})();
